module.exports = __webpack_public_path__ + "media/dashboard/assets/images/video-off-0ba1ef320b8bde494e4e5b81b0c142e4.png";